// ProtectedRoute.js
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Cargando...</div>;
  if (!user) return <Navigate to="/" />;
  if (!allowedRoles.includes(user.rol)) return <Navigate to="/unauthorized" />;

  return children;
};

export default ProtectedRoute;
